import * as React from 'react';
require('./style.css');

interface IProps {
	item: any;
	i: number;
	openEditSection?: (item: any, i: number) => void;
	openDeleteSection?: (i: number) => void;
}

/**
 *
 * @param props
 */
export const MenuItemButtons = (props: IProps) => {
	return (
		<div className="editButtonsMenuItems">
			<button className="btnEdit" type="button" onClick={() => props.openEditSection(props.item, props.i)} />
			<button className="btnDelete" type="button" onClick={() => props.openDeleteSection(props.i)} />
		</div>
	);
};
